import React, { Component } from 'react';
import { connect } from "react-redux";
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ProductMiddleware from "../../store/prat_middleware/gt/productMiddleware";
import './endStock.scss'
import { Loader } from '../../components/loader'
import { convertDecimal3 } from '../../util-functions/util-funtions'
class EndStockPopPup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            page: 1
        }
    }

    componentDidMount() {
        let { selectedProductCategories,
            selectedProductMasterSkus,
            selectedProductBrands,
            selectedProductSkus,
            selectedProductVariants,
            selectedProductFormats } = this.props

        this.props.get_activity_end_stock(this.state.page,
            selectedProductCategories,
            selectedProductBrands,
            selectedProductMasterSkus,
            selectedProductSkus,
            selectedProductVariants,
            selectedProductFormats)
    }



    handleClose = () => {
        this.props.flagHandle()
    };

    handleScroll = (e) => {
        const { activityEndStock, isActivityEndStockLoading, selectedProductCategories,
            selectedProductMasterSkus,
            selectedProductBrands,
            selectedProductSkus,
            selectedProductVariants,
            selectedProductFormats } = this.props
        let bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 50;
        if (bottom && !isActivityEndStockLoading && activityEndStock.results.length < activityEndStock.total_count) {
            let page = this.state.page + 1;
            this.props.get_activity_end_stock(page, selectedProductCategories,
                selectedProductBrands,
                selectedProductMasterSkus,
                selectedProductSkus,
                selectedProductVariants,
                selectedProductFormats)
            this.setState({ page })
        }
    }

    render() {
        return (
            <div className='endstock-table' >
                < Modal
                    className='modal'
                    open={this.props.isOpen}
                    onClose={this.handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={this.props.isOpen} >
                        <div className='endstock-table ' id="scrollbar" style={{
                            width: '90%', background: 'white',
                            padding: '20px',
                            height: '70%',
                            borderRadius: '5px'
                        }} onScroll={e => this.handleScroll(e)}>
                            {this.props.activityEndStock === undefined && <Loader flag={this.props.isActivityEndStockLoading} />}
                            {/* {this.props.activityEndStock && this.props.activityEndStock.results.length > 0 && */}
                            <>
                                <div style={{ height: 40, flexDirection: 'row' }}>
                                    <p className='title-endstock'>End Stock</p>
                                    <p onClick={this.handleClose} className='close-icon' style={{}}>X</p>
                                </div>
                                <TableContainer style={{ height: '90%' }} className='table-main' id="div2" component={Paper}>
                                    <Table stickyHeader aria-label="sticky table" >
                                        <TableHead className='es-table-head'>
                                            <TableRow>
                                                <TableCell className='table-header-td' >Master SKU code</TableCell>
                                                <TableCell className='table-header-td' >SKU code</TableCell>
                                                <TableCell className='table-header-td'>SKU DESC</TableCell>
                                                <TableCell className='table-header-td'>Total End Stock</TableCell>
                                                <TableCell className='table-header-td'>Peshawar</TableCell>
                                                <TableCell className='table-header-td'>Multan</TableCell>
                                                <TableCell className='table-header-td'>Lahore</TableCell>
                                                <TableCell className='table-header-td'>Karachi</TableCell>
                                                <TableCell className='table-header-td'>Islamabad</TableCell>
                                                <TableCell className='table-header-td'>Hyderabad</TableCell>
                                                <TableCell className='table-header-td'>Faisalabad</TableCell>
                                                {/* <TableCell style={{ fontSize: 10 }}>Res 08 ES</TableCell> */}
                                                {/* <TableCell style={{ fontSize: 10 }}>Res 09 ES</TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <>
                                                {this.props.activityEndStock && this.props.activityEndStock.results.length > 0 &&
                                                    this.props.activityEndStock.results.map((itm, ind) => {
                                                        return (
                                                            <TableRow key={ind}>
                                                                <TableCell align="center">{itm.MskuCode}</TableCell>
                                                                <TableCell align="center">{itm.SkuCode}</TableCell>
                                                                <TableCell align="right">{itm.SkuDescription}</TableCell>
                                                                <TableCell align="center">{convertDecimal3(itm.TotalEndStock)}</TableCell>
                                                                <TableCell align="center">{convertDecimal3(itm.Peshawar)}</TableCell>
                                                                <TableCell align="center">{convertDecimal3(itm.Multan)}</TableCell>
                                                                <TableCell align="center">{convertDecimal3(itm.Lahore)}</TableCell>
                                                                <TableCell align="center">{convertDecimal3(itm.Karachi)}</TableCell>
                                                                <TableCell align="center">{convertDecimal3(itm.Islamabad)}</TableCell>
                                                                <TableCell align="center">{convertDecimal3(itm.Hyderabad)}</TableCell>
                                                                <TableCell align="center">{convertDecimal3(itm.Faisalabad)}</TableCell>

                                                            </TableRow>
                                                        )
                                                    })
                                                }
                                                {/* {this.props.activityEndStock != undefined && <Loader flag={this.props.isActivityEndStockLoading && this.props.activityEndStock.results.length > 0} />} */}
                                            </>
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                            </>
                        </div>
                    </Fade>
                </Modal >
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        // product reducer
        activityEndStock: state.ProductReducer.activityEndStock,
        isActivityEndStockLoading: state.ProductReducer.isActivityEndStockLoading,
        // draftData: state.CreatePromotionReducer.draftData,
    };
};

const mapDispatchToProps = dispatch => {
    return {

        // product details
        get_activity_end_stock: (page,
            selectedProductCategories,
            selectedProductBrands,
            selectedProductMasterSkus,
            selectedProductSkus,
            selectedProductVariants,
            selectedProductFormats) => {
            return dispatch(ProductMiddleware.get_activity_end_stock(page,
                selectedProductCategories,
                selectedProductBrands,
                selectedProductMasterSkus,
                selectedProductSkus,
                selectedProductVariants,
                selectedProductFormats));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(EndStockPopPup);
